import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import {
  IHomePageBlockComponent,
  ISearchCta
} from '../../../../typings/pageBlocks'
import ItemsSlideBlock from '../itemsSlideBlock/itemsSlideBlock'
import Button from '../../button'
import SearchLink from '../../../containers/searchLinkContainer'
import { getWindow } from '../../../../common/utils/window'

import * as styles from './qualityItemsBlock.module.css'

interface IProps extends IHomePageBlockComponent {
  title: string
  subtitle?: string
  data: IItem[]
  cta: ISearchCta
}

const reportClick = (eventLabel: string, eventValue?: number) => {
  reportBlockClick('Quality Items', {
    dimension19: 'body',
    eventAction: 'click;link',
    eventLabel,
    eventValue
  })
}

const QualityItemsBlock = ({
  data,
  title,
  subtitle,
  cta,
  currentSite
}: IProps) => {
  return (
    <ItemsSlideBlock
      title={title}
      currentSite={currentSite}
      subtitle={subtitle}
      data={data}
      onItemClick={(item, index) => reportClick(`${item.id}`, index)}
      testSelector="qualityItemsBlock"
    >
      <footer className={styles.footer}>
        <Button
          type={Button.Type.Primary}
          large
          renderAs={SearchLink}
          locationParams={cta.urlSearchParams}
          className={styles.button}
          onClick={() => {
            reportClick(cta.title)
            getWindow().scrollTo(0, 0)
          }}
        >
          {cta.title}
        </Button>
      </footer>
    </ItemsSlideBlock>
  )
}

export default QualityItemsBlock
